var r=864e5,o=e=>Math.floor(e/864e5)*864e5,D=e=>{let t=Date.parse(e);return new Date(Number.isNaN(t)?Number(e):t)};export{r as a,o as b,D as c};
